import { defineMessages } from 'react-intl';

const messages = defineMessages({
  std_notif_txt: {
    id: '9pLB+Z',
    defaultMessage: 'Take me to Standard',
  },
  prem_bullet_1: {
    id: 'tZOMxL',
    defaultMessage:
      'Accelerate climate adaptation and climate risk management.',
  },
  prem_bullet_2: {
    id: '4F6+K9',
    defaultMessage: 'Bring your own data and weather / climate models.',
  },
  prem_bullet_3: {
    id: 'nHSEvC',
    defaultMessage:
      'Configure climate risk management solutions with dashboards, alerts and actionable workflows.',
  },
  std_bullet_1: {
    id: 'KGJFSz',
    defaultMessage: 'Monitor critical job sites and areas.',
  },
  switch3_tag_1: {
    id: '4bPKeJ',
    defaultMessage: 'Crop identification',
  },
  std_bullet_2: {
    id: 'PAou1S',
    defaultMessage:
      'Visualize and stay alerted with dashboards, interactive maps and real-time alerts.',
  },
  switch3_tag_2: {
    id: 'K9meoU',
    defaultMessage: 'Precision KPIs',
  },
  std_bullet_3: {
    id: '9EsNCt',
    defaultMessage:
      'Powered by AI generated current and forecasted weather conditions.',
  },
  switch3_tag_3: {
    id: 'Du/1CN',
    defaultMessage: 'Accurate crop yield',
  },
  switch3_tag_4: {
    id: 'T2SEDA',
    defaultMessage: 'Supply assurance',
  },
  switch3_tag_5: {
    id: 'EfySLS',
    defaultMessage: 'Improved commodity price prediction',
  },
  switch3_tag_6: {
    id: '4nb1Gc',
    defaultMessage: 'NDVI and additional insights',
  },
  slider1_text: {
    id: 'kFsMfM',
    defaultMessage: 'Number of Sites',
  },
  eis_headline: {
    id: 'FpQrXT',
    defaultMessage:
      'Estimate your IBM Environmental Intelligence Suite price based on the scope of your needs',
  },
  est_bullet_1: {
    id: 'R5/gd1',
    defaultMessage:
      'Data scientists and developers can augment operations with accurate environmental data.',
  },
  est_bullet_2: {
    id: '7/5GKc',
    defaultMessage:
      'Any business operations can benefit with accurate and AI-augmented weather forecasts.',
  },
  est_feat_pt1: {
    id: 'qSnQGu',
    defaultMessage: 'Site monitoring dashboards',
  },
  disclaimer_text: {
    id: 'yoX8Av',
    defaultMessage:
      'Calculated prices are estimates provided for planning purposes only taking into account potential IBM discounts, and are not a formal offer from IBM or an IBM Business Partner. The estimation may reflect the total discounted price. Certain factors such as configuration, add-ons, or additional requirements will affect final price. IBM Business Partners set and provide their own IBM EIS pricing, and neither IBM nor IBM Business Partners are bound by the provided estimate.',
  },
  est_feat_pt3: {
    id: 'wQ9W/y',
    defaultMessage: 'Weather alerts',
  },
  switch3_desc: {
    id: 'ytEoOK',
    defaultMessage:
      '{name} leverages predictive analytics and agricultural, environmental, and modeled data to provide insights to farmers, food processors, and distributors about crops, risks, and yields. The insights help to reduce supply chain risk, reduce costs, and provide better quality products.',
  },
  std_desc_part2: {
    id: 'tNzGzH',
    defaultMessage:
      'The industry solutions include {name1} and {name2}. These solutions provide specific insights and leverage AI-enabled models that help forecast current and changing conditions to allow you to schedule and implement mitigation strategies.',
  },
  sites_text: {
    id: 'DDhP4z',
    defaultMessage: 'Sites',
  },
  est_feat_pt2: {
    id: 'eoT+G+',
    defaultMessage: 'Industry operations starter dashboards',
  },
  std_desc_part1: {
    id: 'b8JC7m',
    defaultMessage:
      'The IBM Environmental Intelligence Suite {name1} provides access to our workflow-driven solutions to allow you to optimize, maintain, and forecast your operations. The {name2} includes a state-of-the-art alerting engine to monitor and inform against over 400 weather perils.',
  },
  est_feat_pt5: {
    id: '8fEQ3c',
    defaultMessage: 'Probablistic weather forecasts',
  },
  est_feat_pt4: {
    id: 'cLDfQK',
    defaultMessage: 'Current, future and historical weather data services',
  },
  est_hod_info2: {
    id: 'kZwHoy',
    defaultMessage: '- can add up to 200 000 total, in 10 000 increments',
  },
  estimated_text: {
    id: '2kVSS7',
    defaultMessage: 'Estimated monthly costs',
  },
  est_feat_pt6: {
    id: '+doTPu',
    defaultMessage:
      'Agriculture, renewables, season/sub-seasonal data services',
  },
  est_hod_info1: {
    id: 'Vzaj7m',
    defaultMessage: 'Includes 40 000 HoD API calls',
  },
  est_sites_info1: {
    id: 'ekeC7C',
    defaultMessage: 'Includes 5 sites',
  },
  switch2_desc: {
    id: 'ev5L0F',
    defaultMessage:
      'Assess the impact of both weather and climate change on infrastructure using machine-learning predictive models and determine the correct response to mitigate the impact.',
  },
  api_calls_invalid_text: {
    id: 'iVBP7N',
    defaultMessage:
      'Please provide a API calls range between 200 000 - 1 000 000',
  },
  api_calls_text: {
    id: 'lJycpm',
    defaultMessage: 'API Calls',
  },
  hod_api_calls_invalid_text: {
    id: '0p3DtV',
    defaultMessage:
      'Please provide a HoD API calls range between 40 000 - 200 000',
  },
  std_switch1: {
    id: 'h5hEjH',
    defaultMessage: 'Vegetation Management',
  },
  std_label: {
    id: 'cb2kY6',
    defaultMessage: 'Standard',
  },
  std_switch3: {
    id: 'O2n+YL',
    defaultMessage: 'Crop Yield and Health',
  },
  prem_label: {
    id: 'C5xzTC',
    defaultMessage: 'Premium',
  },
  std_switch2: {
    id: 'B8AvC7',
    defaultMessage: 'Outage Prediction',
  },
  est_sites_info2: {
    id: 'p5zwcf',
    defaultMessage: '- can add up to 25 total, in 1 site increment',
  },
  col1_text: {
    id: 'FCjGve',
    defaultMessage: 'Requirement',
  },
  thank_you: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  switch1_tag_2: {
    id: 'CANcXT',
    defaultMessage: '{name}, Satellite',
  },
  switch1_tag_1: {
    id: 'iU0zEW',
    defaultMessage: 'Custom scoring and species identification',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  estimated_annual_text: {
    id: 'QsT4P9',
    defaultMessage: 'Estimated annual cost',
  },
  tooltip_sites_text: {
    id: '8uA1hr',
    defaultMessage:
      'A Site is a dashboard of a saved set of monitored parameters for a geographic location which is currently being monitored by the Dashboard Visualization Component.',
  },
  switch1_tag_6: {
    id: '/Dv5Zt',
    defaultMessage: 'Work order management integration',
  },
  est_api_info1: {
    id: '5uelR5',
    defaultMessage: 'Includes 200 000 API calls',
  },
  switch1_tag_5: {
    id: 'pa8/MQ',
    defaultMessage: 'Current state identification',
  },
  est_api_info2: {
    id: 'YvH7yD',
    defaultMessage: '- can add up to 1 000 000 total, in 20 000 increments',
  },
  switch1_tag_4: {
    id: 'MTdvX4',
    defaultMessage: 'Asset health',
  },
  prem_notif_label: {
    id: 'vt9nHB',
    defaultMessage: 'Information notification',
  },
  switch1_tag_3: {
    id: '+XuNGF',
    defaultMessage: 'Condition-based maintenance',
  },
  return_est_text: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  sites_invalid_text: {
    id: 'GxoBjP',
    defaultMessage: 'Please provide a Sites range between 5 - 25',
  },
  prcie_text: {
    id: 'cVxiy4',
    defaultMessage: 'Prices shown do not include tax',
  },
  tooltip_api_text: {
    id: 'C6RfQ1',
    defaultMessage:
      'API Call is the invocation of the Cloud Services through a programmable interface. A History on Demand API call is the retrieval of one day, or any portions thereof, of the parameters for the location requested.',
  },
  eis_sub_headline: {
    id: 'PxD+NP',
    defaultMessage:
      'IBM offers flexible pricing options and volume discounts. Request a quote unique to your needs.',
  },
  tooltip_hod_text: {
    id: 'v2YrP5',
    defaultMessage:
      'A History on Demand (HoD) API Call is the retrieval of one day, or any portions thereof, of the parameters for the location returned.',
  },
  slider3_text: {
    id: '6vUxVf',
    defaultMessage: 'Number of {name} Calls',
  },
  bp_desc: {
    id: '9k14Pe',
    defaultMessage:
      'I consent to IBM providing my business contact information: ',
  },
  contact_info: {
    id: 'ic57NA',
    defaultMessage:
      'For more information regarding this offering and industry solutions please get in touch with us.',
  },
  close_btn_text: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  est_label: {
    id: 'eXbuB9',
    defaultMessage: 'Essentials',
  },
  hod_api_calls_text: {
    id: 'dJLJI/',
    defaultMessage: 'HoD API Calls',
  },
  switch2_tag_1: {
    id: 'jzPor/',
    defaultMessage: 'Customer outage communication',
  },
  prem_tag_1: {
    id: '2J9kqU',
    defaultMessage: 'Solution Accelerator',
  },
  switch2_tag_3: {
    id: '9QZtCY',
    defaultMessage: 'Outage response time improvement',
  },
  switch2_tag_2: {
    id: 'bFvwx1',
    defaultMessage: 'Reduced response time',
  },
  switch2_tag_5: {
    id: 'sJlCoA',
    defaultMessage: 'Storm response mobilization',
  },
  switch2_tag_4: {
    id: '26340v',
    defaultMessage: 'Accurate resource allocation',
  },
  recommend_text_std: {
    id: 'o/mpqD',
    defaultMessage: 'Need additional applications or capacity?',
  },
  prem_tag_7: {
    id: '4/o+7e',
    defaultMessage: 'Reduced outages',
  },
  prem_tag_6: {
    id: 'LFNliM',
    defaultMessage: 'Location specific disruption mitigation',
  },
  prem_tag_9: {
    id: '+0W7YL',
    defaultMessage: 'Optimized renewable energy generation',
  },
  std_tab_info: {
    id: 'h4tIEY',
    defaultMessage: 'Select from the Industry Solution tabs to learn more.',
  },
  prem_tag_8: {
    id: 'T2SEDA',
    defaultMessage: 'Supply assurance',
  },
  prem_tag_3: {
    id: '/6zV9X',
    defaultMessage: 'Geospatial Analytics',
  },
  est_feat_label: {
    id: 'ZXp0z1',
    defaultMessage: 'Features',
  },
  prem_tag_2: {
    id: '8qtCUz',
    defaultMessage: 'Enable work queues',
  },
  prem_tag_5: {
    id: 'kxY4CA',
    defaultMessage: 'Wind and solar farm output models',
  },
  prem_tag_4: {
    id: 'GJa2YL',
    defaultMessage: 'Climate Risk Analysis',
  },
  quote_text: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  req_detail: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  package_label: {
    id: 'RcNFA2',
    defaultMessage: 'Package',
  },
  col2_text: {
    id: 'YAINeq',
    defaultMessage: 'Entitlement',
  },
  received_text: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  prem_short_desc: {
    id: 'EPURTq',
    defaultMessage:
      'Industry add-ons include {name}. This industry solution generates high-accuracy forecasts of wind and solar farm assets. Through the use of AI and advanced analytics, sophisticated instrumentation, and best-in-class weather data to help utility operators increase the integration of renewables into the grid while optimizing operational efficiencies, resiliency, and reliability.',
  },
  switch1_desc: {
    id: 'dGFZQ5',
    defaultMessage:
      'Adds industry specific components that use AI, satellite images, LiDAR {name} and more to regularly assess and monitor vegetation across a utility service territory.',
  },
  book_text: {
    id: 'fkklEf',
    defaultMessage: 'Book a Consultation',
  },
  slider2_text: {
    id: '6vUxVf',
    defaultMessage: 'Number of {name} Calls',
  },
  discount_text: {
    id: 'MHPfUK',
    defaultMessage: '10% off your EIS Essentials subscription plan',
  },
});

export default messages;
